(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  function init(root) {
    if (root.dataset.kplReady) return;
    root.dataset.kplReady = 'true';

    var drawer = root.querySelector('[data-kpl-drawer]');
    var form = root.querySelector('[data-kpl-filters]');
    var opener = root.querySelector('[data-kpl-open]');
    var closer = root.querySelector('[data-kpl-close]');
    var sort = root.querySelector('[data-kpl-autosubmit]');

    function submit() {
      if (!form) {
        if (sort) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        }
        return;
      }
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });

      form.addEventListener('change', function (event) {
        if (!desktop.matches) return;
        if (event.target.matches('input[type="checkbox"], input[type="number"]')) submit();
      });
    }

    if (sort) {
      sort.addEventListener('change', submit);
    }

    if (drawer && opener) {
      opener.addEventListener('click', function () {
        if (typeof drawer.showModal === 'function') {
          drawer.showModal();
          document.documentElement.classList.add('kpl-col-lock');
        }
      });

      drawer.addEventListener('close', function () {
        document.documentElement.classList.remove('kpl-col-lock');
        opener.focus();
      });

      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) drawer.close();
      });

      if (closer) {
        closer.addEventListener('click', function () {
          drawer.close();
        });
      }

      desktop.addEventListener('change', function (event) {
        if (event.matches && drawer.open) drawer.close();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-kpl-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
